// Brand/domain values for this deployment. The same code serves different brands
// (e.g. RetirementBrain and MyAdvisorRetirement) by setting these env vars at build time.
// Defaults are the MyAdvisorRetirement values (RB-326). Legal URLs and versions live in config/legal.ts.
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "MyAdvisorRetirement"
export const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN || "myadvisorretirement.ai"
// Contact address; the old retirementbrain.io/.com addresses stay as aliases for 90 days (RB-326).
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || `info@${APP_DOMAIN}`

// Hosts that serve the public landing site instead of the signed-in app.
const LANDING_HOSTS = [
    APP_DOMAIN,
    "myadvisorretirement.com",
    "retirementbrain.io",
    "retirementbrain.ai"
]
export const isLandingHost = (host?: string) => LANDING_HOSTS.includes(host ?? "")
